import type {GAEModule} from "./types.ts";

// The graphql endpoint details for each of the supported modules.
// These endpoints can include a path with `__opname__`, which
// will be replaced by the query's operation-name at query-time.
// See services/fastly-khanacademy-compute/handlers/graphql.go.
// The values here are actually a collection of endpoints:
//    path: the endpoint to use
//    supportsGet: Whether the endpoint supports GET requests
//    supportsFastlyCaching: whether the endpoint supports fastly caching
export const moduleEndpoints: Partial<
    Record<
        GAEModule,
        {
            readonly path: string;
            readonly supportsGet: boolean;
            readonly supportsFastlyCaching: boolean;
        }
    >
> = Object.freeze({
    default: {
        path: "/api/internal/graphql/__opname__",
        supportsGet: true,
        supportsFastlyCaching: true,
    },
    multithreaded: {
        path: "/api/internal/_mt/graphql/__opname__",
        supportsFastlyCaching: true,
        supportsGet: true,
    },
});
